import React, { useContext } from "react";

import { GlobalContext } from "../../globals/globalContext";
import "./styles.styl";

export default function LocationPicker(props) {
  const { colorPrimary } = useContext(GlobalContext) || props;

  const { pickup } = props;
  return (
    <div className="location-picker">
      <div className="location-picker__icon">
        <svg
          width="19"
          height="26"
          viewBox="0 0 19 26"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill={colorPrimary}
            d="M9.5 0C4.24786 0 0 4.069 0 9.1C0 15.925 9.5 26 9.5 26C9.5 26 19 15.925 19 9.1C19 4.069 14.7521 0 9.5 0ZM9.5 12.35C7.62715 12.35 6.10715 10.894 6.10715 9.1C6.10715 7.306 7.62715 5.85 9.5 5.85C11.3729 5.85 12.8929 7.306 12.8929 9.1C12.8929 10.894 11.3729 12.35 9.5 12.35Z"
          />
        </svg>
      </div>
      <div className="location-picker__label">{pickup}</div>
    </div>
  );
}
